module.exports = __webpack_public_path__ + "static/img/花瓶11.ae6c791.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/reliefVase/imgs/花瓶11.png
// module id = 9qzW
// module chunks = 2